import React from 'react'
import Skeleton from 'react-loading-skeleton'

function GridSkeleteon() {
    return (
        <div className="col-lg-3 col-6 grids-feature mt-2">
            <a href={`/`}>
                <div className="area-box">
                    <Skeleton className='card-image' width={`5vh`} height={`5vh`} />
                    <h4 className="title-head"><Skeleton className='card-title' width={`15vh`} height={`3vh`} /></h4>
                </div>
            </a>
        </div>
    )
}

export default GridSkeleteon
